module.exports = __webpack_public_path__ + "img/gb9877_1-88-28x40x7.prt.f5c548ce.jpg";